module.exports = __webpack_public_path__ + "static/media/QRcode.718071da.svg";